const timeout = 1000;

export async function ResolveTest(data) {
  return new Promise((resolve, reject) => {
    window.setTimeout(resolve, timeout);
  }).then(() => {
    console.log('Resolved');
    return {data: data};
  })
}